import { render, staticRenderFns } from "./FinishedTransport.vue?vue&type=template&id=651ce279&scoped=true"
import script from "./FinishedTransport.vue?vue&type=script&lang=js"
export * from "./FinishedTransport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651ce279",
  null
  
)

export default component.exports